
export const FETCH_ALL_DYEING_DETAILS_REQUEST = 'FETCH_ALL_DYEING_DETAILS_REQUEST';
export const FETCH_ALL_DYEING_DETAILS_SUCCESS = 'FETCH_ALL_DYEING_DETAILS_SUCCESS';
export const FETCH_ALL_DYEING_DETAILS_FAILURE = 'FETCH_ALL_DYEING_DETAILS_FAILURE';


export const FETCH_BY_ID_DYEING_DETAILS_REQUEST = 'FETCH_BY_ID_DYEING_DETAILS_REQUEST';
export const FETCH_BY_ID_DYEING_DETAILS_SUCCESS = 'FETCH_BY_ID_DYEING_DETAILS_SUCCESS';
export const FETCH_BY_ID_DYEING_DETAILS_FAILURE = 'FETCH_BY_ID_DYEING_DETAILS_FAILURE';

export const CREATE_DYEING_DETAILS_REQUEST = 'CREATE_DYEING_DETAILS_REQUEST';
export const CREATE_DYEING_DETAILS_SUCCESS = 'CREATE_DYEING_DETAILS_SUCCESS';
export const CREATE_DYEING_DETAILS_FAILURE = 'CREATE_DYEING_DETAILS_FAILURE';

export const UPDATE_DYEING_DETAILS_REQUEST = 'UPDATE_DYEING_DETAILS_REQUEST';
export const UPDATE_DYEING_DETAILS_SUCCESS = 'UPDATE_DYEING_DETAILS_SUCCESS';
export const UPDATE_DYEING_DETAILS_FAILURE = 'UPDATE_DYEING_DETAILS_FAILURE';

export const DELETE_DYEING_DETAILS_REQUEST = 'DELETE_DYEING_DETAILS_REQUEST';
export const DELETE_DYEING_DETAILS_SUCCESS = 'DELETE_DYEING_DETAILS_SUCCESS';
export const DELETE_DYEING_DETAILS_FAILURE = 'DELETE_DYEING_DETAILS_FAILURE';

export const CREATE_USERFORM_DYEING_DETAILS = 'CREATE_USERFORM_DYEING_DETAILS';
export const RESET_DYEING_DETAILS_USERFORM = 'RESET_DYEING_DETAILS_USERFORM';